// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"654":"cc1e6e5a","704":"62e23f24"}[chunkId] + ".chunk.js";
};